<app-spinner></app-spinner>
<div class="container mt-20 pt-10 border-top border-gray-900 border-thick">
  <div class="font-20 semibold m-10">
    Find New Employee
  </div>

  <form [formGroup]="advancedSearchForm">
    <div class="flex gap-20">
      <div class="ds-text-field filter mt-10">
        <input class="ds-text-field__input" id="searchEmployee" type="text" formControlName="lastName"
          autocomplete="off" />
          <label for="address" class="ds-floating-label">*Last Name</label>
          <div class="field-line-ripple blue"></div>
          <span class="help display-none"></span>
          <span class="error display-none"></span>
        </div>
        <div class="ds-text-field filter mt-10">
          <input class="ds-text-field__input" id="searchEmployee" type="date" formControlName="dob"
            autocomplete="off" />
            <label for="address" class="ds-floating-label">*Date of Birth</label>
            <div class="field-line-ripple blue"></div>
            <span class="help display-none"></span>
            <span class="error display-none"></span>
          </div>
        </div>

        <div class="flex gap-20" style="width: 50%;">
          <div class="ds-text-field filter" >
            <input class="ds-text-field__input" id="searchEmployee" type="text" maxlength="4" formControlName="ssn4"
              autocomplete="off" (keyup)="allowOnlyNumbers($event)" />
              <label for="address" class="ds-floating-label">*Last 4 SSN</label>
              <div class="field-line-ripple blue"></div>
              <span class="help display-none"></span>
              @if (advancedSearchForm.get('ssn4').invalid && advancedSearchForm.get('ssn4').errors && (advancedSearchForm.get('ssn4').dirty || advancedSearchForm.get('ssn4').touched)) {
                <div>
                  <span id="add1-errmsg" class="error errmsg">Enter Valid SSN4</span>
                </div>
              }

            </div>
          </div>

          <div class="container mb-20 pt-10 border-top border-gray-900 border-thick flex gap-20" >
            <button class="black hover-blue-800"  type="submit" (click)="search()" [ngClass]="advancedSearchForm.invalid ? 'disabled':''">
              <div class="btn-txt font-white bold">Search</div>
            </button>
            <button type="button" class="secondary border-red rounded-4 hover-red hover-font-white" (click)="clear()">
              <div class="btn-txt font-red bold">Clear Search</div>
            </button>
          </div>
        </form>

        <div class="mb-30 fade">
          <div class="card fluid mb-30">
            <div class="card__content border-bottom border-gray-600">
              <div class="width-full">
                <div class="flex justify-between">
                  <div class="font-20 semibold">Search Results</div>
                  <div class="font-14">Total: {{searchData.length}}</div>
                </div>

                <div class="mt-10 desktop-view">
                  <div class="overflow-auto">
                    <table class="table-ode">
                      <thead>
                        <tr>
                          <th>First Name</th>
                          <th>Middle Name</th>
                          <th>Last Name</th>
                          <th>Email Address</th>
                          <th>Date Of Birth</th>
                          <th>Phone Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (data of searchData; track data) {
                          <tr>
                            <td><a (click)="onEmployeeSelect(data)">{{data.firstName}}</a></td>
                            <td>{{data.middleName}}</td>
                            <td>{{data.lastName}}</td>
                            <td>{{data.emailAddress}}</td>
                            <td>{{data.dateOfBirth | date:'MM/dd/yyyy'}}</td>
                            <td>{{data.phoneNumber}}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mb-20 pt-10 border-top border-gray-900 border-thick flex" style="gap: 64%;">
        <button type="button" (click)="onClickBack()"
          class="secondary border-red rounded-4 hover-red hover-font-white">
          <div class="btn-txt font-red bold">Back</div>
        </button>
      </div>